module.exports = __webpack_public_path__ + "static/media/download.3d1e4253.svg";